import { createFileRoute } from "@tanstack/react-router";
import AddStudentPage from "@/pages/students/add-student";
import PrivateLayout from "@/components/layouts/private-layout";

export const Route = createFileRoute("/_authenticated/students/new")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateLayout>
      <AddStudentPage />
    </PrivateLayout>
  );
}
